import React, { Component } from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import { withRouter } from 'react-router';
import toyotaLogo from '../../../assets/images/toyota.svg';
import { userIsAdmin } from '../../../utils/RolesBasedUsers';
import NavigationItem from './NavigationItem/NavigationItem';
import './NavigationItems.css';

class navigationItems extends Component {
  handleLoginLogout = e => {
    if (e.target.innerText === 'Logout') {
      localStorage.removeItem('httpOther');
      localStorage.removeItem('authToken');
      this.setState({ loginState: 'Logout' });
    }
  };

  render() {
    const isAdmin = userIsAdmin();
    const { location } = this.props;

    return (
      <Navbar bg="light" variant="light" expand="lg">
        <Navbar.Brand href="/">
          <img
            src={toyotaLogo}
            width="50"
            height="50"
            className="d-inline-block align-top logoWrapper"
            alt="React Bootstrap logo"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse className="justify-content-end" id="basic-navbar-nav">
          <Nav className="justify-content-end" activeKey={location.pathname}>
            {isAdmin && (
              <React.Fragment>
                <Nav.Item>
                  <Nav.Link href="/">Dealers</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link href="/dms">DMS</Nav.Link>
                </Nav.Item>
                {/* <Nav.Item>
                  <Nav.Link href="/features">Features</Nav.Link>
                </Nav.Item> */}
                <Nav.Item>
                  <Nav.Link href="/cache">Clear Cache</Nav.Link>
                </Nav.Item>
                <Nav.Item>
              <Nav.Link href="/dashboard">Payments Dashboard</Nav.Link>
            </Nav.Item>
              </React.Fragment>
            )}

            {/* <Nav.Item>
              <Nav.Link href="/reports">Reports</Nav.Link>
            </Nav.Item> */}
            <Nav.Item>
              <Nav.Link href="/login" id="navLoginLogout">
                Login
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
    return (
      <ul className="NavigationItems">
        {isAdmin && (
          <React.Fragment>
            <NavigationItem link="/" active>
              Dealers
            </NavigationItem>
            <NavigationItem link="/dms">DMS</NavigationItem>
            <NavigationItem link="/features">Features</NavigationItem>
            <NavigationItem link="/cache">Cache Clean</NavigationItem>
          </React.Fragment>
        )}
        <NavigationItem link="/reports">Reports</NavigationItem>
        <NavigationItem link="/dashboard">Environment Dashboard</NavigationItem>
        <NavigationItem link="/login" handler={this.handleLoginLogout} navId="navLoginLogout">
          Login
        </NavigationItem>
      </ul>
    );
  }
}

export default withRouter(navigationItems);



// WEBPACK FOOTER //
// ./src/components/Header/NavigationItems/NavigationItems.js